import * as yup from "yup"

export const detailValidationSchema = yup.object().shape({
  qty_return_item: yup.number().label("QTY REFUND").required().moreThan(0).max(yup.ref("qty_back_returned")),
  qty_unit: yup.number().defined(),
  product_barcode: yup.string().defined(),
  product_id: yup.number().defined(),
  product_name: yup.string().defined(),
  price_refund: yup.number().defined(),
  discount: yup.number().defined(),
  total: yup.number().defined(),
  tax_id: yup.number().defined(),
  tax_name: yup.string().defined(),
  tax_rate: yup.number().defined(),
  total_tax_collect: yup.number().defined(),
  qty_back_returned: yup.number().defined(),
  quantity_unit_sell_convention: yup.number().defined(),
  unit_convention_name: yup.string().defined(),
  unit_sell_measure_name: yup.string().defined()
})
export const validationSchema = yup.object().shape({
  memo: yup.string().label("Memo").required(),
  referensi: yup.string().label("Reference").required(),
  total_payment:yup.number().label("Total Payment").defined(),
  transaction_date: yup.string().label("Date").required(),
  trx_code:yup.string().defined(),
  refund_return_detail: yup.array().label("Detail").required().min(1).of(detailValidationSchema)
})

export type FormType = yup.InferType<typeof validationSchema>
export type DetailType = yup.InferType<typeof detailValidationSchema>